import { render, staticRenderFns } from "./_shell.vue?vue&type=template&id=2a17c9a6&"
import script from "./_shell.vue?vue&type=script&lang=js&"
export * from "./_shell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports